import React from 'react';
import { slide as Menu } from 'react-burger-menu'
import './style.scss';
import LogoComponent from '../LogoComponent/LogoComponent';
import DataMenuList from '../DataMenuList/DataMenuList';
export default class BurgerMenu extends React.Component {
    constructor(props) {
        super(props);
    }
    showSettings(event) {
        event.preventDefault();
    }

    render() {
        const { isDataMenuOpen, childrenData, setChildrenList, setDataMenuStatus, dataVisibilities, setDataVisibilityArray, newDataVisibilities, newSetDataListVisibilities, setBoundsDelegateFnc } = this.props;

        // const MainMenu = (
        //     <Menu disableAutoFocus right>
        //         <LogoComponent height="200" width="200" />
        //         <div style={{ marginTop: "10px" }}></div>
        //         <a className="menu-item" href="https://mavivatan.net/mavi-vatan/">
        //             Mavi Vatan Nedir
        //         </a>
        //         <a className="menu-item" href="https://mavivatan.net/hakkimizda">
        //             Hakkımızda
        //         </a>
        //         <a className="menu-item" href="https://mavivatan.net/iletisim">
        //             İletişim
        //         </a>
        //         <div style={{ position: "absolute", bottom: 0, marginRight: "10px" }}>

        //             <p style={{ fontSize: "14px" }}>Harita <b>Doç.Dr. Cihat Yaycı</b> tarafından; <b>İsrail, Filistin ve Lübnan</b> ile deniz yetki alanları sınırlandırma anlaşmaları yapılmışcasına çizilmiştir. <b>MaviVatan.net</b> tarafından dijital ortamda işlenmiştir.</p>
        //             <a style={{ fontSize: "12px" }}>Dijital haritanın tüm hakları <b>MaviVatan.net</b>'e aittir</a>
        //         </div>
        //     </Menu>
        // );
        // NOTE: You also need to provide styles, see https://github.com/negomi/react-burger-menu#styling
        return (
            <Menu
                className="data_menu"
                disableAutoFocus left
                itemListElement="li"
                customBurgerIcon={false}
                isOpen={isDataMenuOpen}
                onStateChange={(state) => setDataMenuStatus(state.isOpen)}
            >
                <div className="menu_top_container">
                    <LogoComponent height="180" width="180" />
                    <div style={{ marginRight: "10px", }}>
                        <a style={{ fontSize: "12px", color: "#fff" }}>Dijital haritanın tüm hakları <b>MaviVatan.net</b>'e aittir</a>
                    </div>
                </div>
                <div style={{ marginTop: "10px" }}></div>
                <DataMenuList setBoundsDelegateFnc={setBoundsDelegateFnc} setChildrenList={setChildrenList} childrenData={childrenData} dataVisibilities={dataVisibilities} setDataVisibilityArray={setDataVisibilityArray} newDataVisibilities={newDataVisibilities} newSetDataListVisibilities={newSetDataListVisibilities} />

            </Menu>
        );
    }
}